import React from "react"
import { Modal, ModalBody } from "@silversea-ssc/ui-components-react"
import useModal from "../ModalProvider/useModal"

// NOTE: Only used for testing. Do not delete
const TestModal: React.FC = () => {
    const { closeModal } = useModal()

    return (
        <Modal
            title={"test modal"}
            size="small"
            modal={{
                isOpen: true,
                onRequestClose: () => closeModal("closeWithCallback"),
                shouldCloseOnEsc: true,
                shouldCloseOnOverlayClick: false,
            }}
            dataContentName="test-modal"
        >
            <ModalBody variant="full" paddingTop={false}>
                Test modal
            </ModalBody>
        </Modal>
    )
}

export default TestModal
